<template lang="pug">
.k-kintell-card-favoutite-count.mr-5
  .d-inline-flex.relative
    v-tooltip(top)
      template(v-slot:activator="{ on }")
        .k-kintell-card-favoutite-count__count.d-flex(v-on="on")
          k-icon(color="grey-0" :size="12") bookmark
          .k-kintell-card-favoutite-count__text.small-caps.grey-0--text {{ value }}
      span.paragraph--small Your card has been favourited {{ value }} {{ pluralize('time', value) }}
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: [ Number, String ]
    }
  },
}
</script>

<style lang="scss" scoped>
.k-kintell-card-favoutite-count {
  &__text {
    left: 17px;
    position: absolute;
    top: 6px;
    transform: translateY(-50%);
  }
}

.v-tooltip__content {
  background-color: grey !important;
  padding: 5px !important;
}
</style>
